function formatDateOrNull(date: Date | null): string | null {
  if (!date) {
    return null;
  }

  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);

  return date.toISOString().split("T")[0];
}

function formatDateTimeOrNull(dateTime: Date | null): string | null {
  if (!dateTime) {
    return null;
  }

  const offset = dateTime.getTimezoneOffset();
  dateTime = new Date(dateTime.getTime() - offset * 60 * 1000);

  const year = dateTime.getFullYear();
  const month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
  const day = ("0" + dateTime.getDate()).slice(-2);
  const hours = ("0" + dateTime.getHours()).slice(-2);
  const minutes = ("0" + dateTime.getMinutes()).slice(-2);
  const seconds = ("0" + dateTime.getSeconds()).slice(-2);

  return (
    year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
  );
}

function isDateAfterTodayOrEqual(date: Date): boolean {
  const currentDate = formatDateOrNull(new Date());
  const formatedDate = formatDateOrNull(date);

  if (!currentDate || !formatedDate) {
    return false;
  }

  return currentDate <= formatedDate;
}

function isDateBeforeTodayOrEqual(date: Date): boolean {
  const currentDate = formatDateOrNull(new Date());
  const formatedDate = formatDateOrNull(date);

  if (!currentDate || !formatedDate) {
    return false;
  }

  return currentDate >= formatedDate;
}

export {
  formatDateOrNull,
  formatDateTimeOrNull,
  isDateAfterTodayOrEqual,
  isDateBeforeTodayOrEqual,
};
